import React, { useEffect, useRef, useState } from "react";
import ContainerWrapper from "../../../Components/ContainerWrapper/container-wrapper";
import { Col, Row } from "antd";
import EmployeeSidebar from "../../../Components/Sidebar/Employee-Sidebar";
import CreateResumeWrapper from "../../CreateResume/components/Create-Resume-Wrapper";
import ViewResumeDashboard from "./view-resume-dashboard";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LayoutHOC from "../../../Components/Hoc/ResumeHoc";
import { deleteResume, view_resume } from "../../../Api/apiService";
import { useDispatch } from "react-redux";
import { selectProfile } from "../../../Redux/ResumeReducer/ResumeAction";
import { toast } from "react-toastify";
import CustomizeButton from "../../../Components/Button/Customize-Button";
import ModalNew from "../../../Components/Modal/modal-new";

const Employee = () => {
  const { id } = useParams();
  const user = JSON.parse(localStorage.getItem("auth"))
  const [profiles, setProfiles] = useState([]);
  const location = useLocation();
  const name = location.state?.name;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedProfileId, setSelectedProfileId] = useState(null);
  const [deletedProfileId, setDeletedProfileId] = useState(null);
  const [showDeleteResumeModal, setShowDeleteResumeModal] = useState(false);
  const resumeRef = useRef();
  const fetchProfiles = async () => {
    setLoading(true);
    try {
      const response = await view_resume(id);
      const activeProfiles = response.data.filter((profile) => !profile.isDeleted);
      setProfiles(activeProfiles);
    } catch (error) {
      console.log("Error fetching profiles");
    }
    setLoading(false);
  };

  const handleSelectProfile = (profileId) => {
    setSelectedProfileId(profileId);
    const selectedProfile = profiles.find((p) => p.id === profileId);

    console.log(selectedProfile, "selected profile");
    if (selectedProfile) {
      dispatch(selectProfile(selectedProfile));
    }
  };

  const handleEdit = (profile) => {
    const selectedProfile = profiles.find((p) => p.id === profile.id);

    console.log(selectedProfile, "selected profile");
    if (selectedProfile) {
      dispatch(selectProfile(selectedProfile));
    }

    navigate(`/personalInfo/?profileId=${profile.id}`);
    window.localStorage.removeItem("profileId");

    window.localStorage.setItem("profileId", profile.id);
  };
  useEffect(() => {
    if (id) {
      fetchProfiles();
    }
  }, [id]);
  useEffect(() => {
    if (profiles.length > 0 && !selectedProfileId) {
      setSelectedProfileId(profiles[0].id);
    }
  }, [profiles]);

  const handleDeleteProfile = (profileId) => {
    console.log("Delete profile with ID:", profileId);
    setDeletedProfileId(profileId);
    setShowDeleteResumeModal(true);
  };

    const confirmDelete = async () => {
      if (!deletedProfileId) return;
      try {
        const deleteResponse = await deleteResume(deletedProfileId);
        if (deleteResponse.data.isDeleted) {
          setShowDeleteResumeModal(false);
          if (selectedProfileId === deletedProfileId) {
            setSelectedProfileId(null);
            dispatch(selectProfile(null));
          }
          fetchProfiles();
          toast.success("Resume deleted successfully!", { autoClose: 1500 });
          setDeletedProfileId(null);
        }
      } catch (error) {
        console.log("Failed to delete resume");
      }
    };
      const colSpan = profiles.length > 0 ? 18 : 24;

  return (
    <>
      <div className="dashboard-container-outer">
        <ContainerWrapper breadcrumbItems={["Dashboard-HR", `Employee`]} userRole={user?.role}>
          <div className="dashboard-inner-container">
            <Row
              style={{
                marginBottom: "12px",
              }}
            >
              <Col span={8}>
                <span
                  style={{
                    fontWeight: "500",
                    fontSize: "24px",
                    marginBottom: "20px",
                    color: "#464646",
                  }}
                >
                  Welcome to Resume Builder {name}
                </span>
              </Col>
              <Col span={16}>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-end",
                  }}
                ></div>
              </Col>
            </Row>
            <Row gutter={[20, 20]}>
              {profiles.length > 0 &&
              <Col span={6}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div>
                    <EmployeeSidebar
                      profiles={profiles}
                      title="Resumes"
                      userId={id}
                      onSelectProfile={handleSelectProfile}
                      selectedProfileId={selectedProfileId}
                      onEditProfile={handleEdit}
                      onDeleteProfile={handleDeleteProfile}
                      onDownloadPDF={() => resumeRef.current?.downloadPDF()}
                      onDownloadWord={() => resumeRef.current?.downloadWord()}
                    />
                  </div>
                </div>
              </Col>
}
              <Col span={colSpan}>
                <CreateResumeWrapper>
                  <div
                    style={{
                      borderRadius: "10px",
                      padding: "16px",
                      border: "1px solid #E8E8E8",
                    }}
                  >
                    <ViewResumeDashboard ref={resumeRef} userId={id} profileId={selectedProfileId} />
                  </div>
                </CreateResumeWrapper>
              </Col>
            </Row>
          </div>
        </ContainerWrapper>
         <ModalNew
          className="delete-modal"
          title={"Delete Resume"}
          visible={showDeleteResumeModal}
          onClose={() => {
            setShowDeleteResumeModal(false);
            setDeletedProfileId(null);
          }}
        >
           <div className="selector-container">
            <div style={{
              display:"flex",
              justifyContent:"center",
              alignContent:"center",
            }}> 
              <span
                style={{
                
                  fontSize: "16px",
                  color: "#000000",
                }}
              >
                Are you sure you want to delete this resume?
              </span>
            </div>

              <div style={{ display: "flex", gap: "10px", width: "100%", marginTop: "20px" }}>
                
              <CustomizeButton style={{
                width:"50%"
              }} variant="primary" onClick={confirmDelete}>
                Confirm
              </CustomizeButton>
             
              <CustomizeButton style={{
                width:"50%"
              }} variant="outlined" onClick={() => setShowDeleteResumeModal(false)}>
                Cancel
              </CustomizeButton>
            </div>
          </div>
        </ModalNew>
      </div>
    </>
  );
};

export default LayoutHOC(Employee);
